import { ReactNode } from "react";

export type SearchResultLayoutProps = {
    rootId?: string;
    children: ReactNode;
}
export type SearchResultLayout = (props: SearchResultLayoutProps) => ReactNode


